import PhoneNumber from '../PhoneNumber';
import Address from '../Address';

export default class ManageContactInfoChanges {
    sameAsPrimaryCHK: boolean;
    addressAdds: Array<Address>;
    phoneNumberAdds: Array<PhoneNumber>;
    addressUpdates: Array<Address>;
    phoneNumberUpdates: Array<PhoneNumber>;
    addressDeleteIds: Array<number>;
    phoneNumberDeleteIds: Array<number>;

    constructor() {
        this.addressAdds = [];
        this.phoneNumberAdds = [];
        this.addressUpdates = [];
        this.phoneNumberUpdates = [];
        this.addressDeleteIds = [];
        this.phoneNumberDeleteIds = [];
    }
}



// WEBPACK FOOTER //
// ./src/models/forms/ManageContactInfoChanges.ts